export const features = [
  { id: 'ai_assistant.view', title: 'View AI Assistant Settings', module: 'ai_assistant' },
  {
    id: 'ai_assistant.settings.manage',
    title: 'Manage AI Assistant Settings',
    module: 'ai_assistant',
    dependsOn: ['ai_assistant.view'],
  },
  {
    id: 'ai_assistant.conversations.manage',
    title: 'Manage AI Assistant Conversations',
    module: 'ai_assistant',
    dependsOn: ['ai_assistant.view'],
  },
  {
    id: 'ai_assistant.conversations.share',
    title: 'Share AI Assistant Conversations',
    module: 'ai_assistant',
    dependsOn: ['ai_assistant.view'],
  },
  {
    id: 'ai_assistant.mcp.serve',
    title: 'Start MCP Server',
    module: 'ai_assistant',
    dependsOn: ['ai_assistant.view'],
  },
  {
    id: 'ai_assistant.tools.list',
    title: 'List MCP Tools',
    module: 'ai_assistant',
    dependsOn: ['ai_assistant.view'],
  },
  {
    id: 'ai_assistant.mcp_servers.view',
    title: 'View MCP Server Configurations',
    module: 'ai_assistant',
    dependsOn: ['ai_assistant.view'],
  },
  {
    id: 'ai_assistant.mcp_servers.manage',
    title: 'Manage MCP Server Configurations',
    module: 'ai_assistant',
    dependsOn: ['ai_assistant.mcp_servers.view'],
  },
]

export default features
